import {classNames, Highlighter, React, useLocalStore, observer, utils, _, useAsObservableSource} from '@api'
import {EditableText} from '@blueprintjs/core'
import {ISidebarDetailsStore, useCardFieldStore, useVipLocalStore} from '@design-board'
import {useCatalogItemSidebarDetailsStore} from '@modules'
import {useCatalog} from '@stores'
import {Fragment, useEffect} from 'react'
import {CatalogFieldRendererProps, FieldRendererContext, FieldRendererStore} from './CatalogFieldRendererStore'
import {fieldRendererValue} from './CatalogFieldRendererValue'
import * as css from './CatalogFieldRenderer.css'

export const CatalogFieldRenderer = observer<CatalogFieldRendererProps>(
  function CatalogFieldRenderer({nestedData, workspace, tabId, section, className, style, align, showLabel, field, field: {field: name}}) {
    // console.log({name, field, align})
    const catalog = useCatalog(),
      detailsStore: ISidebarDetailsStore = useCatalogItemSidebarDetailsStore() ?? {index: workspace?.catalog?.index ?? catalog.index, isSearching: false, adoptionStore: null},
      cardFieldStore = useCardFieldStore(),
      obsProps = useAsObservableSource({tabId, align, section, field}),
      store = useVipLocalStore((ws) => new FieldRendererStore(ws, obsProps, {detailsStore, cardFieldStore}))

    const {isSearching} = detailsStore,
      {settings: {detailLoc: sidebarAlign}} = catalog,
      {
        isDirty, isSearchResult, isCurrentSearchResult, renderer, type, label, searchWords,
        fieldRenderer, editable, catalogField, value: {valAsString}, setRef, readOnly, showFieldBorder
      } = store,
      valueComponent = fieldRendererValue(store)

    useEffect(() => store.registerEffects(), [])

    useEffect(() => {
      if (isCurrentSearchResult) {
        store.ref?.scrollIntoViewIfNeeded(true)
      }
    }, [store.ref, isCurrentSearchResult])

    return (
      _.isEmpty(field) ? <div className={css.emptyCell} data-empty data-sidebar-field></div> :
      <FieldRendererContext.Provider value={store}>
        <div className={classNames(className, css.root)}
             data-card-field={cardFieldStore != null}
             data-sidebar-align={sidebarAlign}
             data-sidebar-field={field.field}
             data-valid={store.isValid}
             data-editable={editable === true}
             data-disabled={readOnly === true}
             data-dirty={isDirty}
             data-is-search-result={isSearching ? isSearchResult : undefined}
             data-is-current-search-result={isCurrentSearchResult ? isCurrentSearchResult : undefined}
             data-type={store.renderer}
             data-renderer={renderer}
             data-field-label={store.field.headerLabel !== false}
             style={_.merge({}, catalogField?.editor?.style, style)}
             onKeyDown={store.onKeyPressNavigation}
             ref={setRef}
             data-field-edit-dependant={showFieldBorder}
             data-field-renderer={fieldRenderer}>
          {
            !valueComponent && renderer == 'text' ? <EditableText
                                                    placeholder={label}
                                                    className={css.editableText}
                                                    disabled={!editable}
                                                    value={valAsString ?? ''}
                                                    multiline={align != 'modal'}
                                                  />
              /*<TextField value={valAsString} label={label} disabled={!editable} className={css.text}/>*/
                                                  : <Fragment>
              {cardFieldStore || !label ? null : ['headerCustomEnumType', 'headerCustomString', 'headerCustomBoolean'].includes(type) ? <span className={css.headerCustomLabel}>{!isSearchResult ? label : <Highlighter textToHighlight={label} searchWords={searchWords}/>}</span> :
                                                 (renderer != 'cards' && renderer != '3d-emersya' && renderer != 'TagList' && <label data-type='label' className={classNames(css.label, {[css.labelOnly]: field.labelOnly})}>{!isSearchResult ? label : <Highlighter textToHighlight={label} searchWords={searchWords}/>}</label>)}
              {field.labelOnly !== true &&
			   <div data-type='value'
              title={_.isString(valueComponent) ? utils.removeTags(valueComponent) as string : undefined}
              data-disabled={readOnly}
              data-editable={readOnly !== false}
              data-renderer={renderer}
              className={css.value}>
                 {_.isString(valueComponent) ? <Highlighter className={css.text} textToHighlight={valueComponent} searchWords={searchWords}/> : valueComponent}
			   </div>}
            </Fragment>
          }
        </div>
      </FieldRendererContext.Provider>)
  })

CatalogFieldRenderer.defaultProps = {}
CatalogFieldRenderer.displayName = 'CatalogFieldRenderer'



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/CatalogFieldRenderer.tsx